import React, { Component } from 'react';
import { Link } from 'react-router';
import $ from 'jquery';

class Header extends Component {
  /**
   * Header is ALWAYS sticky IF window width is between 768 and 1023
   * Header is ONLY sticky at >= 1024 when scrolltop > 0
   */
  get isSticky() {
    let sticky = false;
    if (window.innerWidth >= 1024 && this.scrollTop > 0) {
      sticky = true;
    } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
      sticky = true;
    }

    return sticky;
  }

  componentDidMount() {
    if (window.innerWidth >= 768) {
      $(window).scroll(this.handleScroll);
    }
  }

  scrollTop = 0;

  handleScroll = () => {
    this.scrollTop = $(document).scrollTop();
    if (this.isSticky) {
      $('header').addClass("sticky");
      $('body').css('padding-top', '100px');
    } else {
      $('header').removeClass("sticky");
      $('body').css('padding-top', '145px');
    }
  }

  render() {
    return (
      <header>
        <nav className="navbar navbar-default navbar-fixed-top navbar-inverse">
          <div className="container">
            <div className="navbar-header">
              <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#topnav" aria-expanded="false">
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
              <a href={`tel:${this.props.content.phone}`} className="phoneNumber-xs">
                <i aria-hidden="true" className="fa fa-phone-square"></i>
                <span className="sr-only">{this.props.content.phone}</span>
              </a>
              <h1 style={{ margin: 0, position: 'relative', zIndex: 100 }}>
                <Link className="navbar-brand logo" to="/">C&amp;A</Link>
              </h1>
            </div>

            <div className="collapse navbar-collapse" id="topnav">
              <a href={`tel:${this.props.content.phone}`} className="phoneNumber">{this.props.content.phone}</a>
              <ul className="nav navbar-nav navbar-right">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/gallery/IKEA">Gallery</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><Link to="/calculator">Calculator</Link></li>
                <li><Link to="/feedback">Feedback</Link></li>
              </ul>
              <ul className="nav navbar-nav navbar-right socials">
                <li>
                  <a href="https://facebook.com/cna.net.au" className="pull-right" target="_blank" rel="noopener noreferrer">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_36/v1537795854/misc/fb-logo.png" alt="Find us on Facebook" className="img-responsive logo-fb lazyload" />
                  </a>
                  <a href="https://www.instagram.com/cna.net.au/" className="pull-right" target="_blank" rel="noopener noreferrer">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_36/v1537795854/misc/instagram-logo.png" alt="Follow us on Instagram" className="img-responsive logo-fb lazyload" />
                  </a>
                  {/* <a href="https://pin.it/7eeqpi26sivuap" className="pull-right" target="_blank" rel="noopener noreferrer">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_36/v1537795854/misc/pinterest-logo.png" alt="Follow us on Pinterest" className="img-responsive logo-fb lazyload" />
                  </a>
                  <a href="https://www.linkedin.com/company/c-a-assembly-and-installation-solution/" className="pull-right" target="_blank" rel="noopener noreferrer">
                    <img data-src="https://res.cloudinary.com/cna-net-au/image/upload/c_scale,w_36/v1537795854/misc/linkedin-logo.png" alt="Find us on LinkedIn" className="img-responsive logo-fb lazyload" />
                  </a> */}
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}
export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js